import React, { useEffect, useState } from "react";
import { PortalService } from "services/portal";

const CARD = { background: "var(--bg-card)", borderRadius: 12, border: "1px solid var(--border)", overflow: "hidden" };

const TYPE_STYLES = {
  info: { bg: "#eff6ff", color: "#3b82f6", icon: "fas fa-info-circle" },
  success: { bg: "#ecfdf5", color: "#10b981", icon: "fas fa-check-circle" },
  warning: { bg: "#fef3c7", color: "var(--warning)", icon: "fas fa-exclamation-triangle" },
  error: { bg: "#fef2f2", color: "#ef4444", icon: "fas fa-times-circle" },
};

export function PortalNotificaciones() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    PortalService.getNotifications()
      .then((res) => {
        setNotifications(res.notifications || []);
        setTotal(res.total || 0);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleMarkRead = async (id) => {
    try {
      await PortalService.markNotificationRead(id);
      setNotifications((prev) =>
        prev.map((n) => (n._id === id ? { ...n, read: true } : n))
      );
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
        <p style={{ color: "var(--text-secondary)" }}>Cargando notificaciones...</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--text-primary)", marginBottom: 4 }}>Notificaciones</h1>
        <p style={{ fontSize: 14, color: "var(--text-secondary)" }}>{total} notificaciones en total</p>
      </div>

      {notifications.length === 0 ? (
        <div style={{ ...CARD, padding: 40, textAlign: "center" }}>
          <p style={{ color: "var(--text-muted)", fontSize: 14 }}>No tienes notificaciones</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {notifications.map((n) => {
            const style = TYPE_STYLES[n.type] || TYPE_STYLES.info;
            return (
              <div
                key={n._id}
                style={{
                  ...CARD,
                  padding: "16px 20px",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 14,
                  opacity: n.read ? 0.7 : 1,
                  cursor: n.read ? "default" : "pointer",
                  borderLeft: n.read ? "3px solid transparent" : `3px solid ${style.color}`,
                }}
                onClick={() => !n.read && handleMarkRead(n._id)}
              >
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 8,
                    background: style.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: 2,
                  }}
                >
                  <i className={style.icon} style={{ color: style.color, fontSize: 14 }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                    <p style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)" }}>{n.title}</p>
                    {!n.read && (
                      <span style={{ fontSize: 10, fontWeight: 600, color: style.color, background: style.bg, padding: "2px 8px", borderRadius: 4 }}>
                        Nueva
                      </span>
                    )}
                  </div>
                  <p style={{ fontSize: 13, color: "var(--text-secondary)", lineHeight: 1.5 }}>{n.message}</p>
                  <p style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 6 }}>
                    {n.createdAt ? new Date(n.createdAt).toLocaleString("es-CL") : ""}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
